import { createSlice, createSelector } from '@reduxjs/toolkit';
import { getContactsPage } from 'api/Contacts';
import { fetchWithLanguage } from 'store/helpers';

export const fetchContacts = fetchWithLanguage('fetchContacts', getContactsPage);

const contactsSlice = createSlice({
    name: 'contactsSlice',
    initialState: {
        contacts: {},
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(fetchContacts.fulfilled, (state, action) => {
            state.contacts = action.payload;
        });
    },
});

export const selectContactsPage = createSelector(
    [state => state.contactsPagesState.contacts],
    contacts => contacts.data || {},
);

export default contactsSlice.reducer;
